export const TranslationsPT = {
    // languages
    languages: {
        en: 'English',
        ar: 'عربى',
        bg: 'Bulgaria',
        da: 'Dansk',
        de: 'Deutsch',
        es: 'Español',
        fi: 'Suomi',
        fr: 'Français',
        el: 'Ελληνικά',
        it: 'Italiano',
        id: 'Bahasa Indonesia',
        ja: '日本語',
        km: 'ភាសាខ្មែរ',
        nb: 'Bokmål',
        pt: 'Português',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'Svenska',
        sr: 'Srpski',
        th: 'ภาษาไทย',
        vi: 'Tiếng Việt',
        zh: '中文',
    },
    codes: {
        en: 'EN',
        bg: 'BG',
        ar: 'AR',
        da: 'DA',
        de: 'DE',
        es: 'ES',
        fi: 'FI',
        fr: 'FR',
        el: 'EL',
        it: 'IT',
        id: 'ID',
        ja: 'JA',
        km: 'KM',
        nb: 'NB',
        pt: 'PT',
        pa: 'PA',
        sv: 'SV',
        sr: 'SR',
        th: 'TH',
        vi: 'VI',
        zh: 'ZH',
    },
    short_names: {
        en: 'ENG',
        ar: 'عربى',
        bg: 'BGR',
        da: 'DAN',
        de: 'DEU',
        es: 'ESP',
        fi: 'FIN',
        fr: 'FRA',
        el: 'ELL',
        it: 'ITA',
        id: 'IND',
        ja: '日本語',
        km: 'KHM',
        nb: 'NOB',
        pt: 'POR',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'SVE',
        sr: 'SRP',
        th: 'THA',
        vi: 'VIE',
        zh: '中文',
    },
    // BASE
    phrases: {
        order_online: "Encomendar Online",
        cart: "Carrinho",
        open_24: "24 Horas",
        closed: "Fechado",
        free: "GRÁTIS",
        something_went_wrong: "qualquer coisa correu mal",
        try_again: "tente outra vez",
    },
    constants: {
        calendar: {
            days: {
                monday: "Segunda",
                tuesday: "Terça",
                wednesday: "Quarta",
                thursday: "Quinta",
                friday: "Sexta",
                saturday: "Sábado",
                sunday: "Domingo",
            },
        },
        services: {
            pickup: "Levantar",
            delivery: "Entrega",
            dine_in: "No restaurante",
            table_booking: "Reserva de mesa",
        },
        payment: {
            method: {
                cash: "Dinheiro",
                card: "Cartão",
                stripe: "Cartão de Crédito",
                paypal: "PayPal",
                cardconnect: "Cartão de Crédito",
                paygate_payweb: "PayGate PayWeb",
                poli_pay: "POLi Pay",
                ipay88: "iPay88",
                bambora_apac: "Bambora APAC",
                pesapal: "Pesapal",
                custom: "Personalizar",
            },
            backend_method: {
                cash: "Dinheiro",
                card: "Cartão",
                stripe: "Card/Wallet",
                paypal: "PayPal",
                cardconnect: "CardConnect",
                paygate_payweb: "PayGate PayWeb",
                poli_pay: "POLi Pay",
                ipay88: "iPay88",
                bambora_apac: "Bambora APAC",
                pesapal: "Pesapal",
                custom: "Custom",
            },
            status: {
                success: "Sucesso",
                pending: "Pendente",
                error: "Erro",
                refunded: "Reembolsado",
            },
        },
    },
    components: {
        field: {
            dropzone: {
                remove: "Remover",
                drop_here: "Solte os seus ficheiros aqui ou clique para selecionar um",
                accepts: "Aceita ficheiros {{fileTypes}}",
                errors: {
                    max_files: "Máximo permitido: {{number}}",
                    max_size: "Tamanho máximo permitido: {{kilobytes}} KB",
                },
            },
        },
    },
    // UI
    store: {
        global: {
            errors: {
                dine_in_close: "Estamos fechados neste momento, pelo que não podemos aceitar este pedido. Tente pedir para uma data ou hora posterior.",
            },
            buttons: {
                order: {
                    book_order: "Reservar Mesa / Encomendar Online ",
                    order_online: "Encomendar Online",
                    book_table: "Reserver Mesa",
                    order: "Encomendar",
                    book: "Reservar",
                    cart: "Carrinho",
                    restart: "Recomeçar",
                    closed: "Estamos Fechados",
                    not_accepting: "Não estamos a aceitar pedidos",
                },
            },
        },
        modals: {
            auth: {
                login: "Entrar",
                register: "Registar",
                register_commence: "Continuar",
                register_complete: "Criar Conta",
                register_confirmation_sent: "Um código de confirmação foi enviado para o seu endereço de email. Por favor, insira-o em baixo para prosseguir.",
                register_confirmation_resent: "O código de confirmação foi enviado novamente. Verifique o Spam ou recomece o processo.",
                register_restart: "Recomeçar",
                register_resend_code: "Reenviar código",
                login_placeholder: "E-mail",
                password_placeholder: "Password",
                confirm_password_placeholder: "Confirmar Password",
                confirmation_code_placeholder: "Código de Confirmação de E-Mail",
                accept_terms: "Aceitar Termos & Condições",
                accept_terms_view: "Ver",
                login_facebook: "Entrar com o Facebook",
                login_google: "Entrar com o Google",
                benefits: "Entre ou crie uma conta para guardar todas as encomendas",
                logged_in: "Entrou com sucesso",
                logged_out: "Saiu",
                password_reset: {
                    init_button: "Recuperar a password",
                    init_success: "Enviamos um link para recuperar a sua password. Verifique o seu email.",
                    complete_button: "Reset Password",
                    complete_success: "Password alterada com sucesso! Faça login com a nova password",
                    forgot_password_text: "Esqueceu-se da sua password?",
                    forgot_password_link: "Recuperar a password",
                    remember_password_text: "Lembrou-se da sua password?",
                    remember_password_link: "Voltar",
                    invalid_title: "Link inválido",
                    invalid_description: "Este link não é válido, por favor tente recuperar a sua password novamente",
                    invalid_link: "Fazer Login",
                    title: "Recuperar password",
                    description: "Entre uma nova password para a sua conta",
                },
                error_generic: "Alguma coisa correu mal, por favor tente de novo ou contacte-nos",
                error_accept_terms: "Por favor, aceite os Termos e Condições",
                error_password_length: "A password deve ter 6 caracteres",
                error_social: "Houve um erro, tente de novo ou contacte-nos",
                error_confirmation_code: "Código de confirmação inválido",
                error_invalid_code: "Código de confirmação inválido",
                error_exists: "Esse utilizador já existe",
                error_invalid_email_pass: "Email ou password inválidos",
                error_password_no_match: "As passwords não coincidem",
                error_user_not_found: "O utilizador não existe",
                error_invalid_email: "Email inválido",
                error_invalid_reset_token: "Email de recuperação inválido, tente de novo",
            },
            booking: {
                form: {
                    name: "Nome",
                    email: "E-Mail",
                    phone: "Telefone",
                    number_of_people: "Número de Pessoas",
                    number_of_people_max: "Número de pessoas ({{max_people}} Max)",
                    number_of_people_min: "Número de pessoas ({{min_people}} Min)",
                    number_of_people_max_min: "Número de pessoas (Entre {{min_people}} até {{max_people}})",
                    notes: "Notas / Pedidos Especiais",
                    submit: "Submeter pedido de reserva",
                    email_optional: "(opcional)",
                    date: "Data",
                    duration: "Duração",
                    seating: "Horários disponíveis",
                    number_of_guests: "Número de pessoas",
                    notes_placeholder: "Alergias, ocasião, preferência de lugar",
                    reserving: "A reservar...",
                    reserve_table: "Reservar mesa",
                    please_choose_a_date_and_time: "Por favor, escolha uma data e uma hora.",
                    invalid_people: "O número de pessoas deve estar entre {{min}} e {{max}}.",
                    party_size_max_fallback: "o máximo permitido",
                    loading_available_times: "A carregar horários disponíveis…",
                    select_a_date_to_see_available_times: "Selecione uma data para ver os horários disponíveis.",
                    no_times_available_for_this_date: "Não há horários disponíveis para esta data. Por favor, escolha outro dia.",
                    shift: "Turno",
                    service_times: "Horários de serviço",
                    new_shift: "Novo turno",
                    time: "horário",
                    times: "horários",
                    unavailable: "Indisponível",
                    available: "Disponível",
                    required_name: "Por favor, introduza o seu nome.",
                    required_phone: "Por favor, introduza o seu número de telefone.",
                    required_email: "Por favor, introduza o seu e-mail.",
                    invalid_email: "Por favor, introduza um e-mail válido.",
                    required_terms: "Por favor, aceite os termos antes de reservar.",
                    missing_custom_fields: "Por favor, responda a todas as perguntas obrigatórias.",
                    reservation_is_unavailable: "A reserva não está disponível.",
                    please_contact_the_restaurant_directly: "Por favor, contacte o restaurante diretamente.",
                    almost_done: "Quase pronto",
                    your_details: "Os seus dados",
                    tell_us_who_s_coming: "Diga-nos quem vem para que possamos confirmar a sua reserva.",
                    book_your_table: "Reserve a sua mesa",
                    choose_a_time_that_works_for_you: "Escolha um horário que lhe convenha.",
                    send_your_reservation_request_and_the_restaurant_will_take_care_of_the_rest: "Envie o seu pedido de reserva e o restaurante trata do resto.",
                    select_date: "Selecionar data",
                    standard: "Padrão",
                    minutes: "minutos",
                    next: "Seguinte →",
                    back: "← Voltar",
                    accept_terms: "Aceito os termos e condições.",
                    info_1: "Irá receber uma notificação no seu email quando a sua reserva for aceite.",
                },
                errors: {
                    not_found: "Esta reserva não existe. Talvez tenha sido cancelada",
                    generic: "Alguma coisa correu mal, recarregue a página ou contacte-nos",
                    something_went_wrong: "Alguma coisa correu mal",
                    accept_terms: "Por favor, aceite os Termos e Condições",
                    required_phone: "Por favor, introduza o seu número de telefone",
                    required_email: "Por favor, introduza o seu email",
                    required_name: "Por favor, introduza o seu nome",
                    invalid_email: "Por favor, introduza um email válido",
                    invalid_phone: "Por favor, introduza um telefone válido",
                    invalid_people: "Número de pessoas inválido",
                    booking_capacity_threshold: "Estamos lotados para este horário. Por favor, tente outro horário.",
                    slot_unavailable: "Estamos lotados para este número de pessoas. Por favor, tente outro horário.",
                    booking_date_paused: "As reservas estão pausadas para esta data. Por favor, escolha outro dia.",
                    invalid_table_assignment: "Essas mesas não comportam o seu grupo. Por favor, escolha outro horário.",
                    exceeded_order_limit: "Demasiados pedidos de reserva. Por favor, tente novamente mais tarde.",
                    validation_failed_recaptcha_v3: "Tráfego invulgar detetado. Está a usar uma VPN? Conclua o desafio acima e tente novamente.",
                    validation_failed_recaptcha_v2: "Não foi possível iniciar a reserva. Por favor, tente novamente ou use outro método. Se estiver a usar uma VPN, experimente desligá-la primeiro.",
                    booking_already_exists: "Esta reserva já foi enviada. Verifique o seu e-mail ou abra o link da reserva.",
                    invalid_party_size: "Por favor, escolha um número de pessoas válido.",
                    invalid_request: "Pedido inválido. Por favor, atualize a página e tente novamente.",
                    table_booking_unavailable: "A reserva de mesa não está disponível.",
                },
            },
            cart: {
                title: "Carrinho",
                proceed_to_checkout: "Seguir para o Checkout",
                edit_dish: "Editar",
                remove_dish: "Remover",
                no_items_1: "O carrinho está vazio",
                no_items_2: "Adicione itens ao carrinho para prosseguir",
                free_delivery_notice: "Entrega grátis para encomendas superior a {{value, currency}}",
                errors: {
                    min_order_promo: "Faça uma encomenda no valor mínimo de {{value, currency}} para aplicar esta promoção",
                    min_order_delivery: "Para entrega, faça uma encomenda no mínimo de {{value, currency}}",
                },
                promo: {
                    heading: "Promoção",
                    placeholder: "Insira o seu código promocional",
                    add: "Adicionar código",
                    title: "Promo {{name}} adicionada ao carrinho",
                    fixed_discount: "desconto de {{value, currency}}",
                    percent_discount: "Menos {{value}}%",
                    added_to_cart: "Promoção aplicada",
                    errors: {
                        not_found: "Promoção não encontrada",
                        disabled: "A promoção expirou",
                        not_available: "A promoção já não está disponível",
                        logged_in_only: "Tem de fazer login para usar esta promoção",
                        already_used: "Já usou esta promoção",
                        invalid: "Esta promoção já expirou",
                        invalid_service: "Esta promoção não está disponível para o serviço que escolheu",
                        later_only: "Válida apenas para pré-reservas",
                        now_only: "Válida apenas para encomendas imediatas e não para pré-reservas",
                        generic: "Oops... alguma coisa correu mal e não ficou registada!",
                        dishes_required_multi: "Esta promoção só será aplicada a alguns pratos do seu carrinho",
                        dishes_required_single: "Esta promoção só será aplicada a '{{dish}}'",
                    },
                },
                tip: {
                    title: "Gorjeta",
                    placeholder: "Adicione uma gorjeta",
                },
            },
            checkout: {
                title: "Checkout",
                subtitle: "Confirme o seu pedido",
                details: {
                    service: "Serviço",
                    due: "Para",
                    due_now_asap: "Agora / Assim que possível",
                    address: "Morada de entrega",
                    total: "Total",
                    table: "Mesa",
                    store_location: "Morada da loja",
                },
                customer: {
                    title: "Cliente",
                    subtitle: "Faça login para guardar o seu pedido",
                    button: "Login",
                    name: "Nome",
                    email: "E-Mail",
                    phone: "Número de telefone",
                    phone_important: "Número de telefone (Importante)",
                    notes: "Pedidos especiais",
                    delivery_notes: "Instruções para entrega / Notas",
                    optional: "Opcional"
                },
                payment: {
                    title: "Método de pagamento",
                },
                accept_terms: "Aceite os Termos & Condições",
                accept_terms_view: "Ver",
                processing_order: "A processar o pedido",
                warning: {
                    different_payment_currency: "O preço da encomenda está em {{store_currency}} mas o método de pagamento está em {{payment_currency}}",
                    closing_soon: "Vamos encerrar em breve, faça o seu pedido dentro de {{value}} minutos",
                    closed: "Desculpe, a cozinha já está encerrada e não estamos a aceitar novos pedidos",
                    expired: "Já não conseguimos entregar o seu pedido. Por favor, seleccione outra data ou hora.",
                },
                errors: {
                    stripe_generic: "Ocorreu um erro, tente outra vez ou seleccione outro método de pagamento",
                    stripe_loading_fail: "Não conseguimos processar o pagamento, por favor volte a tentar",
                    something_went_wrong: "Ocorreu um erro",
                    paypal_generic: "Ocorreu um erro com o PayPal, tente outra vez ou seleccione outro método de pagamento",
                    payment_fail: "O pagamento falhou, por favor volte a tentar ou seleccione outro médodo",
                    payment_cancelled: "Pagamento cancelado, por favor volte a tentar ou seleccione outro médodo",
                    payment_error: "Erro ao processar o pagamento, por favor volte a tentar ou seleccione outro médodo",
                    payment_declined: "O seu pagamento foi recusado",
                    card_declined: "O seu cartão foi recusado e não conseguimos processar o pagamento",
                    promo_max_uses_exceeded: "Este código promocional atingiu o limite de utilização e já não está disponível.",
                    store_closed: "Estamos encerrados e já não aceitamos novos pedidos",
                    accept_terms: "Por favor, aceite os Termos & Condições",
                    required_payment: "Por favor, seleccione outro método de pagamento",
                    required_phone: "Por favor, introduza o seu número de telefone",
                    required_email: "Por favor, introduza o seu email",
                    required_name: "Por favor, introduza o seu nome",
                    invalid_email: "Por favor, introduza um email válido",
                    invalid_phone: "Por favor, introduza um número de telefone válido",
                    invalid_cc_number: "O seu cartão de crédito é inválido",
                    retry_cc_number: "Ocorreu um erro, volte a introduzir o seu número de cartão de crédito e tente de novo",
                    closed: "Estamos encerrados e não aceitamos novos pedidos",
                    promo_login_required: "Tem de fazer login para usar esta promoção",
                    promo_used: "Já utilizou esta promoção",
                },
                button: {
                    continue: "Continue para o Pagamento",
                    place_order: "Fazer Pedido",
                },
            },
            customer: {
                age_v: {
                    title: "Verificação de Idade",
                    required_for_items: "Obrigatória para encomendar álcool",
                    min_age: "Idade mínima: {{age}} anos",
                    est_time: "A verificação demora aproximadamente {{time}} horas",
                    upload_description: "Faça upload do seu documento de identificação. Será notificado por email quando confirmarmos a sua idade. Faça upload de 2 imagens com o máximo de 2 MB cada",
                    pending_description_1: "Obrigada por submeter os seus documentos. Será notificado por email assim que os verificarmos.",
                    pending_description_2: "Recarregue a página para actualizar o seu processo. A verificação demora aproximadamente {{time}} horas",
                    approved_description: "A sua conta foi verificada e pode pedir todos os itens no menu",
                    rejected_description: "O seu documento foi rejeitado. Se quiser voltar a tentar, envie uma nova imagem",
                    upload: "Upload",
                    reupload: "Voltar a enviar documentos",
                    go_back: "Voltar",
                    view_document: "Ver Documento {{number}}",
                    status: {
                        unverified: "Por verificar",
                        pending: "À espera de verificação",
                        approved: "Verificado com sucesso",
                        rejected: "Rejeitado",
                    },
                },
                headings: {
                    sessions: "Sessões",
                    orders: "Pedidos",
                    spend: "Gastos",
                    order_history: "Histórico de Pedidos",
                    loyalty_points: "Puntos de lealtad",
                },
            },
            custom_payment: {
                title: "{{name}} Formulário de pagamento",
                description: "Chegou ao nosso formulário de pagamento. Por favor, preencha os campos abaixo para prosseguir. Se não tiver nada no seu carrinho, guardaremos os seus dados mas não será cobrado.",
                disabled: "Este tipo de pagamento não está configurado. Por favor, contacte-nos para rectificar o erro.",
                success: "O seu pagamento foi processado e a encomenda foi registada. Obrigado",
                back: "Voltar",
                fields: {
                    name: "Nome",
                    email: "E-mail",
                    reference: "Referência para pagamento",
                    amount: "Montante ($)",
                    name_on_card: "Nome no Cartão",
                    submit: "Submeter Pagamento",
                },
                warning: {
                    currency: "Nota: pagamento em {{actual}}, e não em {{default}}",
                },
                errors: {
                    generic: "Alguma coisa correu mal, volte a tentar ou contacte-nos",
                    stripe_generic: "Ocorreu um erro, recarregue a página e volte a tentar",
                    payment_fail: "O pagamento falhou, por favor tente de novo ou escolha outro método de pagamento",
                    payment_cancelled: "O pagamento foi cancelado, por favor tente de novo ou escolha outro método de pagamento",
                    payment_error: "Ocorreu um erro ao processar o pagamento, por favor tente de novo ou escolha outro método de pagamento",
                    payment_declined: "O seu pagamento foi recusado",
                    card_declined: "O seu cartão foi recusado e o pagamento não foi processado",
                    promo_max_uses_exceeded: "Este código promocional atingiu o limite de utilização e já não está disponível.",
                },
            },
            dish: {
                add: "Adicionar ao Carrinho",
                edit: "Actualizar",
                notes: "Pedidos Especiais...",
                ingredients: {
                    title: "Ingredientes",
                    uncheck_remove: "Remover",
                },
                ingredients_title: "Ingredientes",
                combo: {
                    choose_dish: "Escolha um Prato",
                },
                option_sets: {
                    conditions: {
                        select_one: "Escolha um (Obrigatório)",
                        select_one_optional: "Escolha um (Opcional)",
                        select_between: "Escolha entre {{min}} - {{max}} (Obrigatório)",
                        select_at_least: "Escolha pelo menos {{qty}} (Obrigatório)",
                        select_up_to: "Escolha até {{qty}} (Opcional)",
                        select_multiple: "Escolha múltiplos (Opcional)",
                        free_amount: "Primeiros {{qty}} Grátis / {{selected}} no seu carrinho",
                    },
                },
                error: "Por favor corrija os campos marcados a vermelho",
                added_to_cart: "Item Adicionado ao Carrinho",
            },
            map: {
                zone_fee: "Taxa de Entrega",
                view_in_google: "Ver no Google Maps",
            },
            portal_go_back: {
                title: "Voltar à procura de restaurantes?",
                description: "Quaisquer itens no seu carrinho serão perdidos",
                cancel: "Cancelar",
                proceed: "Voltar atrás",
            },
            order: {
                config: {
                    services: {
                        title: "Escolher um Serviço",
                        table_booking: "Reservar Mesa",
                    },
                    address_custom: {
                        input_placeholder: "Insira a sua morada",
                    },
                    address: {
                        input_placeholder: "Coloque uma morada de entrega",
                        extras_placeholder: "Opcional: número da porta, andar, nome do edifício, etc...",
                        search_placeholder: "Procure a sua morada",
                        not_found: "Morada de entrega inválida ou não encontrada, tente de novo",
                        not_delivering: "No momento, não estamos entregando neste endereço",
                        not_in_range: "Seu endereço não está perto da localização da nossa loja",
                        not_in_zone: "YSeu endereço não está dentro de uma zona de entrega ativa",
                    },
                    datetime: {
                        title: "Quando gostaria de levantar o seu pedido?",
                        due_now: "Agora",
                        due_later: "Mais Tarde",
                        service_not_available: "Desculpe, nesse momento não estamos a aceitar pedidos para {{service}}",
                        currently_closed: "O serviço de {{service}} encontra-se encerrado neste momento, mas pode agendar o seu pedido para mais tarde.",
                        due_unavailable: "Indisponível",
                        due_closed: "Fechado",
                        select_date: "Selecionar data",
                        select_time: "Selecionar hora",
                        select_order_date: "Selecione a data do seu pedido",
                        select_order_time: "Selecione o horário do seu pedido",
                        select_booking_date: "Selecione sua data de reserva",
                        select_booking_time: "Selecione seu horário de reserva",
                        no_times_available: "Não há horários disponíveis para você escolher",
                        date_today: "(Hoje)",
                        date_closed: "(Fechado)",
                        date_bookings_paused: "(Reservas pausadas)",
                        time_slot_closed: "Fechado",
                    },
                    number_of_people: {
                        placeholder: "Número de Pessoas",
                    },
                    table: {
                        select: "Select Table",
                        select_popup_title: "Selecionar mesa",
                        password: "Senha da mesa",
                        password_warning: "Insira a senha da sua mesa para continuar",
                    },
                    warning: {
                        closed: "Desculpe, no momento, estamos fechados / não estamos a aceitar pedidos",
                        not_available: "Desculpe, no momento não estamos a aceitar pedidos",
                    },
                    eta: {
                        delivery: `Tempo de entrega estimado é aproximadamente {{minutesToCustomer}} minutos`,
                        pickup: `O pedido estará pronto em aproximadamente {{minutesToCustomer}} minutos`,
                    },
                    start_button: "Iniciar pedido",
                },
                history: {
                    invalid: "Não é elegível para reordenar, pois alguns dos itens solicitados foram modificados ou não estão mais disponíveis",
                },
                reorder: {
                    title: "Pedido rápido",
                    description: "Faça o pedido facilmente, utilize os seus pedidos anteriores",
                },
            },
            receipt: {
                errors: {
                    not_found: "Pedido não encontrado, atualize a página e tente novamente",
                    booking_not_found: "A reserva não existe. Pode ter sido eliminada",
                    generic: "Ocorreu um erro, atualize a página ou entre em contato",
                },
                connection: {
                    connected: "Atualizações em tempo real",
                    connecting: "Conectando atualizações em tempo real ",
                    disconnected: "Desconectadas atualizações em tempo real ",
                },
            },
            warnings: {
                logout: {
                    pretitle: "Aviso",
                    title: "Logout",
                    body: "O logout removerá todos os itens que foram adicionados ao seu carrinho",
                    cancel: "Cancelar",
                    proceed: "Continuar",
                },
                order_restart: {
                    warning: "Aviso",
                    title: "Detalhes da alteração do pedido",
                    body: "Alterar os detalhes do pedido removerá os itens do seu carrinho, pois determinados pratos podem ficar indisponíveis",
                    cancel: "Cancelar",
                    proceed: "Continuar",
                },
                order_expired: {
                    subtitle: "Importante",
                    title: "Pedido alterado para pronto imediatamente",
                    description: "O horário selecionado para o seu pedido não está muito distante. Dessa forma, seu pedido foi modificado para pronto imediatamente / o mais rápido possível",
                    button: "Ok",
                },
                order_expiring: {
                    subtitle: "Importante",
                    title: "Prazo para o pedido expira brevemente",
                    description: "Seu pedido deve ser feito antes de {{time, timeFromTimestamp}} caso contrário, não será mais válido",
                    button: "Ok",
                },
            },
        },
        sections: {
            nav_top: {
                guest: "Guest",
                login: "Login",
                login_signup: "Login / inscrição",
                logout: "Logout",
            },
            menus: {
                info: {
                    no_menus: "Atualmente não há menus disponíveis",
                    restrictions: "Restrições de menu",
                    not_available: "Menu atualmente indisponível",
                    unavailable: {
                        times: "Menu indisponível, os requisitos do seu pedido não correspondem abaixo",
                        services: "Menu indisponível, os requisitos do seu pedido não correspondem abaixo",
                        hours: "Menu indisponível, o horário do seu pedido não está dentro deste horário disponível",
                        pre_order: "Menu indisponível, a sua encomenda não corresponde aos requisitos de pré-encomenda",
                        age: "Menu indisponível, você deve fazer login com uma conta confirmada por idade para fazer o pedido neste menu",
                    },
                    services: {
                        title: "Requisitos para pedidos",
                        pickup: "Levantar",
                        delivery: "Entregas",
                        dine_in: "Refeição no Restaurante",
                    },
                    times: {
                        now: "Sem pré-encomendas",
                        later: "Somente pré-encomendas",
                    },
                    hours: {
                        title: "Horário disponível",
                    },
                    preorder: {
                        title: "Requisitos de pré-encomenda",
                        days_in_advance: "É necessário solicitar {{days}} dias de antecedência",
                        cutoff_time: "Hora final do último dia às {{time, timeFromTime}}",
                    },
                    age_restricted: {
                        title: "Restrição por Idade",
                        approved: "Sua conta foi confirmada e você pode fazer o pedido neste menu",
                        rejected: "Requer verificação de idade para fazer o pedido. Crie uma conta e faça o upload do seu BI",
                    },
                },
            },
            info: {
                location: {
                    title: "Localização",
                    view_map: "Visualizar mapa",
                    phone: "Telefone",
                },
                hours: {
                    title: "Horário de funcionamento",
                    title_special: "Horário de funcionamento especial",
                },
                services: {
                    title: "Serviços",
                    notes: "Notas",
                    delivery: {
                        ranges: "intervalos de entrega",
                        zones: "zonas de entrega",
                        view_zones: "Visualizar zonas no mapa",
                        fee: "Taxa de entrega",
                        fee_short: 'Taxa',
                        fee_varies: "Varia, mostrado no carrinho",
                        min_order: "Pedido mínimo",
                        min_order_short: 'Ped. mín.',
                        no_min_order: "Sem pedido mínimo",
                        free_amount: "Entrega grátis Quantidade",
                    },
                },
            },
            contact: {
                title: "Contacte-nos",
                name: "Nome",
                email: "E-mail",
                phone: "Número de Telefone",
                message: "Insira a sua mensagem...",
                send: "Envia mensagem",
                success: "Sua mensagem foi enviada com sucesso",
                error: "Ocorreu um erro. Tente novamente ou mais tarde",
            },
            footer: {
                powered_by: "Powered By",
                terms_and_conditions: "Termos e Condições",
            },
        },
    },
    // MODELS
    booking: {
        receipt: {
            title: 'Recibo de reserva',
            details: {
                datetime: 'Reserva pata',
                number_of_people: 'Número de Pessoas',
                placed: 'Feito',
                updated: 'Ultima atualizaçã',
                notes: 'Notas',
                name: 'Nome',
                email: 'E-Mail',
                phone: 'Número de Telefone',
                store_address: 'Endereço da Loja',
            },
            status_update: {
                title: 'Reserva {{number}} Actualizada',
                body: 'Seu status de reserva foi atualizado para {{status}}',
            },
            email_status_update_customer: {
                subject: 'Reserva #{{number}} – {{subjectLabel}}',
                body: 'A sua reserva #{{number}} em {{store}} está agora {{status}}.',
            },
            errors: {},
        },
    },
    email_delayed_order: {
        subject: 'Pedido #{{number}} – {{subjectLabel}}',
        header: 'Hora de preparação atualizada',
        title: 'Hora de preparação atualizada',
        order_number: 'Número do pedido: {{number}}',
        description: 'O seu pedido ficará pronto às {{time}}.',
        order_time_updated_to: 'A hora do seu pedido foi atualizada.',
        powered_by: 'Distribuído por {{name}}',
        button_text: 'Acompanhar Pedido',
        subject_label: 'Hora de preparação atualizada',
        subject_label_delivery: 'Hora de entrega atualizada',
        body_ready: 'O seu pedido ficará pronto às {{time}}.',
        body_delivery: 'O seu pedido será entregue às {{time}}.',
    },
    order: {
        receipt: {
            est_ready_time: 'Tempo estimado de disponibilidade',
            est_driver_pickup_time: 'Tempo estimado de retirada do driver',
            est_delivery_time: 'Tempo estimado de entrega',
            tab_details: 'Detalhes',
            tab_dishes: 'Pratos',
            details: {
                status: 'Status',
                placed: 'Feito',
                due: 'Due',
                due_asap: 'Now / ASAP',
                last_updated: 'Última atualização',
                total: 'Total',
                type: 'Tipo',
                table: 'Mesa',
                number_of_people: 'Numero de pessoas',
                payment_method: 'Método de pagamento',
                payment_status: 'Status do pagamento',
                payment_currency: 'Moeda de Pagamento',
                notes: 'Notas',
                name: 'Nome',
                email: 'E-Mail',
                phone: 'Telefone',
                distance: 'Distançia',
                driving_time: 'Tempo de condução',
                delivery_zone: 'Zona',
                delivery_address: 'Endereço de Entrega',
                delivery_tracking: 'Rastreamento de entrega',
                delivery_tracking_link: 'link de rastreamento em tempo real',
                tookan_status: 'Tookan Status',
                tookan_status_failed_book: 'Falha no pedido',
                tookan_status_failed_update: 'Falha ao atualizar a reserva',
                tookan_status_success: 'Reservado para entrega',
                store_address: 'Endereço da Loja',
            },
            dishes: {
                headings: {
                    quantity: 'quantidade',
                    item: 'Item',
                    price: 'Preço',
                },
                notes: 'Notas',
                remove_ingredients: 'Remover ingredientes',
            },
            status_update: {
                title: 'Pedido {{number}} Actualizado',
                body: 'O status do seu pedido foi atualizado para  {{status}}',
            },
            wait_time_update: {
                title: 'Pedido {{number}} Actualizado',
                body: 'O prazo de entrega do seu pedido foi atualizado',
            },
            delivery_update: {
                title: 'Pedido {{number}} Actualizado',
                body: 'Seu pedido foi reservado para entrega. Consulte o link de rastreamento em tempo real',
            },
            payment_status_update: {
                title: 'Order {{number}} Updated',
                body: 'Your order payment status has been updated.',
            },
            email_new_order_restaurant: {
                subject: "New Order ({{number}}) - {{name}}",
                powered_by: "Powered By {{name}}",
                overview: "New Order Notification",
                title: "New Order Placed At {{name}}",
                subtitle: "Order Number {{number}}",
                description: "View details and updates through your admin dashboard",
                button_text: "Acompanhar Pedido",
                track_delivery_button_text: "Acompanhar entrega",
            },
            email_new_order_customer: {
                subject: "Order Receipt ({{number}})",
                powered_by: "Powered By {{name}}",
                overview: "New Order Notification",
                title: "New Order Placed At {{name}}",
                subtitle: "Order Number {{number}}",
                description: "View details and updates through your real-time online receipt",
                button_text: "Acompanhar Pedido",
                track_delivery_button_text: "Acompanhar entrega",
            },
        },
        totals: {
            tax: "{{name}} ({{percent}}%)",
            tax_in_prices: "{{name}} ({{percent}}%) inc. no preço",
            fee: "{{name}} ({{value, currency}} + {{percent}}%)",
            fee_percent: "{{name}} ({{percent}}%)",
            fee_fixed: "{{name}}",
            delivery_fee: "Taxa de entrega",
            promo: "Desconto: {{name}} ({{value, currency}} + {{percent}}% Off)",
            promo_percent: "Desconto: {{name}} ({{percent}}%)",
            promo_fixed: "Desconto: {{name}}",
            promo_none: "Desconto: {{name}}",
            cart: "Carrinho",
            tip: "Gorjeta",
            total: "Total",
        },
        status: {
            unconfirmed: "Não confirmado",
            awaiting_payment: "Aguardando Pagamento",
            confirmed: "Confirmado",
            ready: "pronto",
            on_route: "Na rota",
            complete: "Completo",
            cancelled: "Cancelado",
            seated: "Sentado",
        },
    },
    restaurant: {
        menus: {
            option_set: {
                option: {
                    unavailable: "Indisponível",
                },
            },
            dish: {
                no_stock: "Fora de estoque",
                not_available: "Não disponível",
            },
        },
    },
};
//# sourceMappingURL=pt.js.map